export default {
  closeNotification (state) {
    state.notificationData = Object.assign({}, {
      show: false,
      message: '',
      type: ''
    })
  },
  openNotification (state, payload) {
    state.notificationData = Object.assign({}, {
      show: true,
      message: payload.message,
      type: payload.type
    })
  },
  openConfirm (state, payload) {
    state.confirm = Object.assign({}, {
      show: true,
      title: payload.title,
      message: payload.message,
      callback: payload.callback,
      width: payload.width
    })
  },
  closeConfirm (state) {
    state.confirm = Object.assign({}, {
      show: false,
      title: '',
      message: '',
      callback: null
    })
  },
  increaseLoading (state) {
    state.loading.count++
  },
  decreaseLoading (state) {
    state.loading.count--
  }
}
